import { createApp } from 'vue';
import modalRdv from '@organisms/offer/modal-rdv-component.vue';
import { URL_USER_SETTINGS_ONBOARDING_MATCH_RDV } from '@tools/routes/routes';
import { userSettingMixin } from './user-setting';

/**
 * Init RDV Modal Vue
 */
export const calendly = () => {
  const component = {
    components: {
      modalRdv,
    },
    mixins: [ userSettingMixin ],
    data() {
      return {
        isRDVModalOpened: false,
      };
    },
    mounted() {
      this.showRDVModal();
    },
    methods: {
      showRDVModal: function showRDVModal() {
        this.isRDVModalOpened = true;
      },
      closeRDVModal: function closeRDVModal() {
        this.isRDVModalOpened = false;
        this.enableUserSetting(URL_USER_SETTINGS_ONBOARDING_MATCH_RDV);
      },
    },
  };

  return createApp(component).mount('.rdv');
};
